import { loadModule } from "features/shared/helpers/modules";
import React, { ReactElement } from "react";

interface IProps { 
  imgPath: string;
  className?: string;
  alt?: string;
  fluid?: boolean;
}
  
const Image : React.FC<IProps> = (props) => {
  const {imgPath, className, alt, fluid} = props;
  const image = loadModule<any>(`images/${imgPath}`);

  const imgClasses = (propsClass?: string, fluid?: boolean) => {
    if (propsClass !== undefined || fluid) {
      let propsClassName = propsClass !== undefined ? ` ${propsClass}` : "";
      let fluidClassName = fluid ? "img-fluid" : "";

      return `${fluidClassName}${propsClassName}`;
    }
    else {
      return undefined;
    }
  };

  return (    
    <img src={image.default} className={imgClasses(className, fluid)} alt={alt}/>
  );
}; 

Image.defaultProps = {
  className: undefined,
  alt: undefined,
  fluid: true
};

export default Image;